import PropTypes from "prop-types";

export const propTypes = {
  children: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  color: PropTypes.string,
};
